


























import Vue from 'vue'
export default Vue.extend({
    name: 'rd-switch',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        contrast: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleSelect() {
            this.$emit('input', !this.value)
        }
    }
})
